import { render, staticRenderFns } from "./BillInvalid.vue?vue&type=template&id=20af390b&"
import script from "./BillInvalid.vue?vue&type=script&lang=js&"
export * from "./BillInvalid.vue?vue&type=script&lang=js&"
import style0 from "./BillInvalid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports